<template>
  <div>
    <AppModal
      v-if="modalToggle"
      :btnCase="btnCase"
      @modalSignCancel="modalSignCancel"
      @modalSignCheck="modalSignCheck"
    />
    <div class="app-wrap" ref="scroll">
      <AppNotifyHeader/>
      <div class="no-data" v-if="alertData">
        <img src="@/assets/img/ic_error_36.png" alt="no-data">
        <p>{{ $t('notificationEmpty') }}</p>
      </div>
      <div class="notify-group" v-else>
        <div class="notify-list" v-for="(list, index) in showList" :key="index">
          <img :src="alertImg(list.companyType)" :art="`companyType${list.companyType}Ic`">
          <div class="notify-box">
            <div class="notify-top">
              <span class="notify-title">{{ list.alarmTitle }}</span>
              <span class="notify-time">{{ formatDateTime(list.postDt) }}</span>
            </div>
            <div class="notify-mid">
              {{ list.alarmContent }}
            </div>
            <div class="notify-bot" @click="orderListDetail(list)">
              자세히보기
            </div>
          </div>
        </div>
      </div>
      <button class="full-notify-btn" v-if="moreBtn">
        <div @click="moreList">더보기</div>
      </button>
      <!-- <button class="full-login-btn" @click="moreList" v-if="!alertData">
        더보기
      </button> -->
      <div class="goTop" @click="scrollToTop" v-if="goBtnFlag && !alertData"></div>
      <!-- <button class="notify-top-btn" @click="scrollToTop" v-if="!alertData"></button> -->
    </div>
    <OrderDetailPopUp :appOrder="appOrder"/>
  </div>
</template>

<script lang="js">
import AppNotifyHeader from '@/components/Header/AppNotifyHeader.vue'
import service from '@/backend/modnpay_app_api'
import { formatDateTime } from '@/utils/DateTime'
import { THROW_APP_ERROR, THROW_APP_LOGIN_OVER_LAP } from '@/router'
import OrderDetailPopUp from '@/components/PopUp/OrderDetailPopUp.vue'
import OrderDetailMixin from '@/utils/OrderDetailMixin'
import { APP_NOTIFY_NAME } from '@/utils/EndPoint'

/* eslint-disable eqeqeq */
export default {
  components: {
    AppNotifyHeader,
    OrderDetailPopUp
  },
  mixins: [OrderDetailMixin],
  name: APP_NOTIFY_NAME,
  data () {
    return {
      modalToggle: false,
      btnCase: 3,
      showCount: 10,
      getAlertList: [],
      beforeWeek: false,
      appOrderCode: 0,
      goBtnFlag: false, // 뒤로가기버튼
      container: null // 뒤로가기버튼
    }
  },
  created () {
    this.alertList()
  },
  mounted () {
    // 뒤로가기버튼 이벤트
    this.container = document.querySelector('.app-wrap')
    this.container.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    // 뒤로가기버튼 이벤트
    this.container.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    showList () { // 10개씩 잘라서 보여주기
      return this.getAlertList.slice(0, this.showCount)
    },
    alertImg () { // companyType 아이콘
      return (companyType) => {
        /*
        0: 모든상품
        1: 유노비전 A,
        2: 노량진버전
        3: 유노비전 B버전
        4: 드림하이테크 매장
        5: 쇼핑가맹점,
        6: 모든포스
        **/
        return companyType == 5 ? require('@/assets/img/ic_delivery.png') : companyType == 2 ? require('@/assets/img/ic_seafood.png') : require('@/assets/img/ic_food.png')
      }
    },
    alertData () { // data Bool
      return this.getAlertList.length == 0
    },
    moreBtn () {
      return this.showCount < this.getAlertList.length
    }
  },
  methods: {
    formatDateTime,
    async alertList () { // 알림함 목록 조회
      const req = {
        userCode: ''
      }
      const { data } = await service.alertList(req)
      const code = data.resultCode

      if (code == 0) {
        this.getAlertList = data.alertList
        this.beforeWeek = data.beforeWeek
        this.appPushShow()
      } else if (code == 15033) {
        THROW_APP_LOGIN_OVER_LAP()
      } else {
        THROW_APP_ERROR()
      }
    },
    appPushShow () { // 앱 푸시 누르고 알림함 들어왔을때
      if (this.$route.query.orderCode) {
        const order = this.getAlertList.find(obj => obj.orderCode === this.$route.query.orderCode)
        this.orderListDetail(order)
        // this.alertDetail(this.appOrderCode)
        this.$router.replace({ query: null })
      } else {
        this.checkAndShowOrder()
      }
    },
    moreList () { // 더보기 버튼
      if (this.beforeWeek && this.getAlertList.length < this.showCount) {
        this.modalToggle = true
      } else {
        this.showCount += 10
      }
    },
    handleScroll () {
      if (this.container && this.container.scrollTop > 0) {
        this.goBtnFlag = true
      } else {
        this.goBtnFlag = false
      }
    },
    scrollToTop () {
      if (this.container) {
        this.container.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    // scrollToTop () { // 상단으로 스크롤 이동
    //   this.$refs.scroll.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    // },
    modalSignCancel () { // 회원가입 취소
      this.modalToggle = false
    },
    modalSignCheck () { // 회원가입 이동
      this.$router.push({ name: 'AppLogin' })
    }
  }
}
</script>

<style scoped>
.pb60{
  padding-bottom: 60px;
}
</style>
